export class InitConstant
{
    public static readonly IS_DEBUG = true;
    public static readonly INIT_TOKEN = '2ca523ee26a8bcf4b151250de4146edd86915c4124e061f02b5f82fa6e280aa0043229c1c7aaaa24e78964b9641bd940f25006f5c0766d76810812d9e185cf10';
    public static readonly MAX_UPLOAD_SIZE = 5368709120;
    public static readonly MAX_SPLIT_SIZE = 52428800;
    public static readonly UPLOAD_SPLIT_SIZE = 10485760;
    public static readonly PROFILE_ICON_SIZE = 3145728;
    public static readonly PROFILE_NAME_SIZE = 64;
    public static readonly PROFILE_EMAIL_SIZE = 100;
    public static readonly PROFILE_PASSWORD_MIN_SIZE = 6;
    public static readonly PROFILE_PASSWORD_MAX_SIZE = 255;
    public static readonly MAX_LIST_VIEW_COUNT = 60;
    public static readonly MAX_POST_LIMIT_COUNT = 100;
    public static readonly MAX_UPLOAD_LIMIT_COUNT = 999;
    public static readonly MAX_TOTAL_UPLOAD_SIZE = 53687091200;

    public static readonly PREVIEW_MIME_TYPES = [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/bmp',
            'image/x-ms-bmp'
     ];

    public static readonly THUMBNAIL_MIME_TYPES = [
            'image/jpeg',
            'image/png',
            'image/heif',
            'image/heic',
            'image/gif',
            'image/bmp',
            'image/tiff',
            'image/x-tiff',
            'image/x-ms-bmp',
            'application/pdf',
            'video/mp4',
            'video/x-msvideo',
            'video/webm',
            'video/quicktime',
            'video/x-matroska',
            'video/avi'
     ];

    public static readonly PROFILE_EMPTY_ICON = 'background-image: url(/assets/images/profile.png);';
}
export class UrlConstant
{
    public static readonly BASE = 'https://nc.rnet.jp/pc/api';
    //public static readonly BASE = 'https://hozon-data.sp-site.jp/pc/api';
    public static readonly LOGIN = '/login';
    public static readonly LOGOUT = '/logout';
    public static readonly FILELIST = '/list/file';
    public static readonly GETFILE = '/getfile';
    public static readonly GETBREADCRUMBS = '/getbreadcrumb';
    public static readonly ADDFAVORITE = '/favorite';
    public static readonly REMINDER = '/reminder';
    public static readonly CREATE = '/create';
    public static readonly CANCEL = '/cancel';
    public static readonly PROFILE = '/profile';
    public static readonly PROFILEICON = '/profileicon';
    public static readonly UPDATE_PROFILEICON = '/profile/icon';
    public static readonly UPDATE_PROFILENAME = '/profile/dispname';
    public static readonly UPDATE_PROFILEEMAIL = '/profile/email';
    public static readonly UPDATE_PROFILEPASSWORD = '/profile/password';
    public static readonly UPDATE_PROFILEDEVICE = '/profile/device';
    public static readonly THUMBNAIL = '/thumbnail';
    public static readonly TRASH = '/trash';
    public static readonly DOWNLOAD = '/download';
    public static readonly RENAME = '/rename';
    public static readonly MOVE = '/move';
    public static readonly COPY = '/copy';
    public static readonly WARNING = '/warning';
    public static readonly REMINDERSEND = '/remindersend';
    public static readonly APPROVEEMAIL = '/approveemail';

    public static readonly PC_FILELIST = '/search';

    public static readonly PC_ZIPARCHIVES = '/ziparchives';
    public static readonly PC_ZIPDOWNLOAD = '/zipdownload';
    public static readonly PC_ZIPPROGRESS = '/zipprogress';
    public static readonly PC_DIRECTDL = '/directdl';

    public static readonly TERM_URL = 'https://hozon.sp-site.jp/hozon_kiyaku.html';
    public static readonly POLICY_URL = 'https://hozon.sp-site.jp/privacy.html';
    public static readonly HOWTO_URL = 'https://hozon.sp-site.jp/howto';
}

export class DialogConstant
{
    public static readonly CONFIRM_TITLE = '確認';
    public static readonly ERROR_TITLE = 'エラー';
    public static readonly INFO_TITLE = 'お知らせ';

    public static readonly BUTTON_OK = 'OK';
    public static readonly BUTTON_CANCEL = 'キャンセル';

    public static readonly LOGOUT_CONFIRM = 'ログアウトしてよろしいですか？';
    public static readonly LOADING_MESSAGE = '読み込み中...';
    public static readonly PROCCESS_ARCHIVE_MESSAGE = '圧縮中...';
    public static readonly PROCCESS_LOADING_MESSAGE = '処理中...';

    public static readonly AUTH_ERR = '認証情報が無効です。再度ログインしてください。';
    public static readonly NOTFOUND_ERR = 'ファイルまたはフォルダが見つかりません。既に削除されている可能性があります。';
    public static readonly REQUEST_ERR = '不正なリクエストです。';
    public static readonly INTERNAL_ERR = '問題が発生したためサーバーと通信できませんでした。';
    public static readonly INSUFFICIENTSTORAGE_ERR = 'サーバーのアップロード容量が上限に達しています。';
    public static readonly MAINTENANCE_ERR = '現在サーバーメンテナンス中です。';
    public static readonly NETWORK_ERR = '通信環境が不安定のためサーバーと通信できません。';

    public static readonly REMINDER_COMPLETE_TITLE = '送信完了';
    public static readonly REMINDER_COMPLETE_MESSAGE = 'ご登録いただいているメールアドレスにパスワード再設定用のURLを送信いたしましたのでご確認ください。';
    public static readonly REMINDER_SEND_COMPLETE_TITLE = '変更完了';
    public static readonly REMINDER_SEND_COMPLETE_MESSAGE = 'パスワードの変更が完了しました。';
    public static readonly REMINDER_SEND_PASSWORD_ERROR = 'パスワードを入力してください。';
    public static readonly REMINDER_SEND_SIZE_ERROR = '{SIZE}文字以上で入力してください。';
    public static readonly REMINDER_SEND_PASSWORDCONFIRM_ERROR = 'パスワード(再入力)を入力してください。';
    public static readonly REMINDER_SEND_PASSWORD_UNMATCH_ERROR = 'パスワードと一致していません。';
    public static readonly REMINDER_SEND_CONFIRM_MESSAGE = 'パスワードを変更してよろしいですか？';
    public static readonly REMINDER_SEND_URL_ERROR = 'このパスワード再設定用URLは無効です。';

    public static readonly UPDATE_PROFILE_ICON_SIZE_ERR = 'プロフィール画像は{SIZE}MB以内のファイルを選択してください。';
    public static readonly UPDATE_PROFILE_ICON_DELETE_CONFIRM = 'プロフィール画像を削除してよろしいですか？';

    public static readonly UPDATE_PROFILE_NAME_TITLE = '表示名の変更';

    public static readonly UPDATE_PROFILE_EMAIL_TITLE = 'メールアドレスの変更';
    public static readonly UPDATE_PROFILE_EMAIL_EMPTY_MESSAGE = 'パスワード再発行のご案内、パスワード変更をお知らせするメールをお送りするため、メールアドレスを設定してください。';

    public static readonly UPDATE_PROFILE_PASSWORD_TITLE = 'パスワードの変更';
    public static readonly UPDATE_PROFILE_PASSWORD_SIZE_ERROR = '{SIZE}文字以上で入力してください。';
    public static readonly UPDATE_PROFILE_PASSWORD_UNMATCH_ERROR = 'パスワードと一致していません。';
    public static readonly UPDATE_PROFILE_PASSWORD_EMPTY_EMAIL_ERROR = 'メールアドレスが登録されていない場合、パスワードの変更はできません。';

    public static readonly UPDATE_PROFILE_DEVICE_TITLE = 'デバイスの管理';
    public static readonly UPDATE_PROFILE_DEVICE_COFIRM = '選択したデバイスを削除してよろしいですか？';

    public static readonly UPDATE_PROFILE_BULK_COFIRM = '{NAME}を更新してよろしいですか？';

    public static readonly TRASH_RESTORE_COFIRM = '「{NAME}」を復元してよろしいですか？';
    public static readonly TRASH_RESTORES_COFIRM = '選択したファイルを復元してよろしいですか？';
    public static readonly TRUSH_DELETE_COFIRM = '「{NAME}」を削除してよろしいですか？';
    public static readonly TRUSH_DELETES_COFIRM = '選択したファイルを削除してよろしいですか？';
    public static readonly TRUSH_DELETEALL_COFIRM = 'ゴミ箱を空にしてよろしいですか？';

    public static readonly FILE_FAVORITE_ADD_SUCCESS = 'お気に入りに追加しました。';
    public static readonly FILE_FAVORITE_DEL_SUCCESS = 'お気に入りから削除しました。';
    public static readonly FILE_FAVORITE_ADD_LIMIT_ERR = '同時にお気に入りに追加できるのは100件まです。';
    public static readonly FILE_FAVORITE_DEL_LIMIT_ERR = '同時にお気に入りから削除できるのは100件まです。';

    public static readonly FILE_DOWNLOAD_CONFIRM_MESSAGE = '{NAME}をダウンロードしますか？';
    public static readonly FILE_DOWNLOAD_LIMIT_ERR = '同時にダウンロードできるのは100件まです。';

    public static readonly FILE_MOVE_SAME_ERR = '移動元と移動先のフォルダが同じです。';
    public static readonly FILE_MOVE_SUCCESS = '{NAME}を移動しました。';
    public static readonly FILE_MOVE_LIMIT_ERR = '同時に移動できるのは100件まです。';

    public static readonly FILE_TRASH_ADD_COFIRM = '「{NAME}」をゴミ箱へ移動しますか？';
    public static readonly FILE_TRASH_ADD_SUCCESS = 'ゴミ箱へ移動しました。';
    public static readonly FILE_TRASH_ADD_LIMIT_ERR = '同時にゴミ箱へ移動できるのは100件まです。';
    public static readonly FILE_TRASH_RESTORE_LIMIT_ERR = '同時にゴミ箱から復元できるのは100件まです。';
    public static readonly FILE_TRASH_DELETE_LIMIT_ERR = '同時にゴミ箱から削除できるのは100件まです。';

    public static readonly FILE_COPY_SUCCESS = 'ファイルをコピーしました。';

    public static readonly FILES_FAVORITE_SUCCESS = '選択したファイルをお気に入りに追加しました。';
    public static readonly FILES_FAVORITE_DEL_SUCCESS = '選択したファイルをお気に入りから削除しました。';
    public static readonly FILES_MOVE_SUCCESS = '選択したファイルを移動しました。';
    public static readonly FILES_DELETE_CONFIRM = '選択したファイルをゴミ箱へ移動しますか？';
    public static readonly FILES_DELETE_SUCCESS = '選択したファイルをゴミ箱へ移動しました。';

    public static readonly UPLOAD_FILE_SIZE_ERR = '{FILE_NAME}はファイルサイズが大き過ぎます。(最大：5GB)';
    public static readonly UPLOAD_FILE_ERR = 'ファイルのアップロードに失敗しました。';
    public static readonly UPLOAD_PARENT_ID_ERR = 'アップロード先のフォルダがありません。';
    public static readonly UPLOAD_FILE_MAX_ERR = '同時にアップロード可能なファイル数の合計は{MAX_UPLOAD_LIMIT_COUNT}ファイルまでです。';
    public static readonly UPLOAD_SIZE_MAX_ERR = '同時にアップロード可能なファイルサイズの合計は50GBまでです。';

    public static readonly UPLOAD_CONFIRM_REUPLOAD = '「{FILE_NAME}」はアップロード中の同名ファイルが存在します。強制的にアップロードしますか？';
    public static readonly UPLOAD_CONFIRM_OVERWRITE = '「{FILE_NAME}」は既に存在します。上書きしますか？';
    public static readonly UPLOAD_CONFIRM_BUTTON_OK = 'はい';
    public static readonly UPLOAD_CONFIRM_BUTTON_RENAME = '名前を変えてアップロード';

    public static readonly FILES_ARCHIVES_SUCCESS = '選択したファイルをダウンロードリストに追加しました。';
    public static readonly FILE_DOWNLOAD_ERR = 'ファイルをダウンロードできません。';
    public static readonly FILE_DOWNLOAD_BUSY_ERR = 'サーバー処理中につきダウンロードできません。';

    public static readonly PROFILE_EMAIL_CONFIRM_MESSAGE = '確認メールをお送りしました。<br>確認メールに記載のURLにアクセスして変更を承認してください。';
}

export class MessageConstant
{
    public static readonly FORBIDDEN_CHAR_ERR = '使用できない文字が含まれています。';

    public static readonly APPROVE_EMAIL_MESSAGE = '処理中...';
    public static readonly APPROVE_EMAIL_SUCCESS = 'メールアドレスを更新いたしました。';
    public static readonly APPROVE_EMAIL_ERR = 'このURLは有効期限が切れている、もしくは無効なURLです。';

}